import axios from 'axios';
import API_URL from './index';
import authHeader from './auth-header';

export default async function getRequests() {
  const headers = {
    'content-type': 'application/json',
    Authorization: authHeader(),
  };

  try {
    const response = await axios.get(`${API_URL}/buyer/home`, { headers });
    return response.data;
  } catch (error) {
    console.log({ error });
    return error;
  }
}
